module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("itNPT"))).then(() => parcelRequire('2KbAe'));